export enum Server {
  TELEHEALTH = 'telehealth',
  MONOLITH = 'monolith',
}
